import moment from "moment";
import { getDate } from "./date";

export const convertTimeToWorkOrderShortHandTime = (time = "") => {
  if (!time || !moment(time).isValid()) {
    return "--";
  }

  const date = getDate(time);
  const month = date.month() + 1;
  const day = date.day();
  const hours = date.hours();
  const minutes = date.minutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${month}/${day} @ ${formattedHours}:${formattedMinutes}${ampm}`;
};
